import { render } from "./AtomBadge.vue?vue&type=template&id=194eefc5&scoped=true&ts=true"
import script from "./AtomBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomBadge.vue?vue&type=script&lang=ts&setup=true"

import "./AtomBadge.vue?vue&type=style&index=0&id=194eefc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194eefc5"],['__file',"src/components/atoms/AtomBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "194eefc5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('194eefc5', __exports__)) {
    api.reload('194eefc5', __exports__)
  }
  
  module.hot.accept("./AtomBadge.vue?vue&type=template&id=194eefc5&scoped=true&ts=true", () => {
    api.rerender('194eefc5', render)
  })

}


export default __exports__